import { Button as ThemeUiButton } from "theme-ui";

import { InfoIcon } from "components/icons";
import * as styles from "./InfoButton.styles";

export default function InfoButton({ children, ...props }) {
  return (
    <ThemeUiButton variant="unstyled" sx={styles.infoButton} {...props}>
      <InfoIcon />
      {children}
    </ThemeUiButton>
  );
}
